import { useEffect, useState }          from "react";
import { Typography }                   from "@gupshup-frontend/gupshup-ts-components";

import { TEMPLATE_PREVIEW_DATA_TESTID } from "./constant";
import styles                           from "./style.module.css";

const TimeStamp = ({ timezone = "" }) => {

  const [ timeStamp, setTimeStamp ] = useState("");

  useEffect(() => {
    updateTimeStamp();
    const intervalId = setInterval(() => updateTimeStamp(), 60000);
    return () => {
      clearInterval(intervalId);
    };
  },[]);

  const updateTimeStamp = () => {
    const now = new Date();
    const timeZoneToUse = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formatter = new Intl.DateTimeFormat('en-US', {
      hour     : 'numeric',
      minute   : 'numeric',
      hour12   : true,
      timeZone : timeZoneToUse,
    });

    setTimeStamp(formatter.format(now));
  };

  return (
    <Typography className = {styles.timeStamp} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.TIMESTAMP}>
      {timeStamp}
    </Typography>
  );
};

export default TimeStamp;
